import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectProgressService } from "../Types/ProjectProgress/ProjectProgressService";
import { ProjectProgress } from "../Types/ProjectProgress/ProjectProgress";
import { fetchProjectProgressData, fetchProjectProgressServiceData } from "../Thunks/projectProgressThunks";

interface ProjectProgressSliceState {
    // Project Progress data
    loadingProjectProgress: boolean;
    projectProgresses: ProjectProgress[];
    errorProjectProgress: string | null;
    isFetchedProjectProgress: boolean;

    // Project Progress Service data
    loadingProjectProgressService: boolean;
    projectProgressServices: ProjectProgressService[];
    errorProjectProgressService: string | null;
    isFetchedProjectProgressService: boolean;
}

// set inital values
const initialState: ProjectProgressSliceState = {
    loadingProjectProgress: false,
    projectProgresses: [],
    errorProjectProgress: null,
    isFetchedProjectProgress: false,

    loadingProjectProgressService: false,
    projectProgressServices: [],
    errorProjectProgressService: null,
    isFetchedProjectProgressService: false,
}

// set state value for api response
const projectProgressSlice = createSlice({
    name: 'projectProgress',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            // For Project Progress list data
            .addCase(fetchProjectProgressData.pending, state => {
                state.loadingProjectProgress = true;
                state.errorProjectProgress = null;
            })
            .addCase(fetchProjectProgressData.fulfilled, (state, action: PayloadAction<ProjectProgress[]>) => {
                state.projectProgresses = [];
                state.loadingProjectProgress = false;
                state.projectProgresses = action.payload;
                state.isFetchedProjectProgress = true;
            })
            .addCase(fetchProjectProgressData.rejected, (state, action) => {
                state.loadingProjectProgress = false;
                state.errorProjectProgress = action.error.message ?? 'Failed to fetch project progress data';
                state.isFetchedProjectProgress = true;
            })


            // For Project Progress service list data
            .addCase(fetchProjectProgressServiceData.pending, state => {
                state.loadingProjectProgressService = true;
                state.errorProjectProgressService = null;
            })
            .addCase(fetchProjectProgressServiceData.fulfilled, (state, action: PayloadAction<ProjectProgressService[]>) => {
                state.projectProgressServices = [];
                state.loadingProjectProgressService = false;
                state.projectProgressServices = action.payload;
                state.isFetchedProjectProgressService = true;
            })
            .addCase(fetchProjectProgressServiceData.rejected, (state, action) => {
                state.loadingProjectProgressService = false;
                state.errorProjectProgressService = action.error.message ?? 'Failed to fetch project progress service data';
                state.isFetchedProjectProgressService = true;
            })
    }
})

export default projectProgressSlice.reducer
